import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./WhyBlueBerry.css";
import Heading from "../../../utls/Heading";

const WhyBlueBerry = () => {
  return (
    <>
      <div className="container whyBBCardContainer">
        <div className="whyBBCardBox my-4">
          <div className="col-lg-6 col-md-6 col-sm-12 ms-2">
            <Heading level={2} className="headings mt-2 ps-2 ps-md-0 whyBBCardHeading">
              <span>What Makes </span>Blueberry Your Ideal Global Partner
              <b style={{ fontWeight: "700" }}>?</b>
            </Heading>
            <p className="whyBB-txt my-4 ps-2 grotesk-headings">
              With over 10 years of expertise in the travel industry, Blueberry
              Travels offers flawless global travel solutions for businesses,
              leisure travelers, students, and more. Whether you’re planning
              business trips, group travel, or events, we combine local
              knowledge with worldwide reach to deliver customized solutions
              that exceed clients’ expectations.
            </p>
            <h4 className="fw-bold ps-2 pointers-head">
              Exclusive Benefits for Travel Partners:
            </h4>
            <ul className="fs-5 whyBB-txt ms-4 p-0 grotesk-headings">
              <li className="circle-color ">
                Effective reservation platform, no downloads required
              </li>
              <li className="circle-color ">
                Instant booking confirmations and real-time availability
              </li>
              <li className="circle-color ">
                A vast selection: 450+ airlines, 500,000+ hotels, transfers, &
                more.
              </li>
              <li className="circle-color">
                {" "}
                Competitive prices and exclusive rates for our partners
              </li>
              <li className="circle-color ">
                Flexible payment options to suit your needs
              </li>
              <li className="circle-color ">
                Effortless single and multi-product reservations
              </li>
              <li className="circle-color ">
                Plam multi-destination trips with ease
              </li>
              <li className="circle-color ">
                Auto-generated vouchers and invoices for your convenience
              </li>
              <li className="circle-color">
                Quick and simple changes or cancellations online
              </li>
              <li className="circle-color ">
                Dedicated offline services for added support
              </li>
            </ul>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 ms-4 travelarrangementimg">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/whybbImg.png"
              alt=""
              className="whyBBTravelimg"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyBlueBerry;
